// import React, { Component } from 'react';
// import axios from 'axios';
// // import { FaAppStore } from "react-icons/fa";
// // import { AiOutlineDatabase } from "react-icons/ai";
// // import { CiPen } from "react-icons/ci";
// // import { GiBlackBook } from "react-icons/gi";
// // import { LuNotebook } from "react-icons/lu";
// // import { MdOutlineVerifiedUser } from "react-icons/md";
// // import { GiField } from "react-icons/gi";
// // import { MdOutlinePhoneInTalk } from "react-icons/md";
// // import { PiCertificate } from "react-icons/pi";
// // import { MdOutlineVerified } from "react-icons/md";


// class AddCourseUploader extends Component {
//   state = {
//     title: '',
//     description: '',
//     price: 0,
//     trainingType: '',
//     repeat: 'Select Repeat Type',
//     interval: '',
//     duration_from: '',
//     Updateduration_from: '',
//     duration_to: '',
//     Updateduration_to: '',
//     packageOptions: [],
//     courseLabel: '',
//     courseTag: '',
//     selectedImage: null,
//     selectedImages: null,
//     isActive: false,
//     windowHeight: window.innerHeight - 60,
//     repeatDisabled: false, // State to track Repeat disable status
//     durationDisabled: false,
//     loading: false, // Added loading state

//     datePairs: [
//       {
//         id: 1,
//         duration_from: '',
//         duration_to: '',
//       },
//     ],
//     nextId: 2,

//   };
//   // for the image 
//   fileInputRef = React.createRef();







//   // getIconForOption = (option) => {
//   //   switch (option) {
//   //     case 'Software':
//   //       return <FaAppStore />;
//   //     case 'Data':
//   //       return <AiOutlineDatabase />;
//   //     case 'Biro':
//   //       return <CiPen />;
//   //     case 'Jotter':
//   //       return <LuNotebook />;
//   //     case 'Manual':
//   //       return <GiBlackBook />;
//   //     case '100% Practical':
//   //       return <MdOutlineVerifiedUser />;
//   //     case 'Field Experience':
//   //       return <GiField />;
//   //     case 'Free Consultation':
//   //       return <MdOutlinePhoneInTalk />;
//   //     case 'Exam and Certificate':
//   //       return <PiCertificate />;
//   //     case 'Free internship':
//   //       return <MdOutlineVerified />;
//   //     case 'Access job opportunities':
//   //       return <MdOutlineVerified />;
//   //     default:
//   //       return null;
//   //   }
//   // };


//   // start of the handle submition


//   handleInputChange = (event) => {

//     const { name, value, type, checked, dataset } = event.target;

//     const pairId = parseInt(dataset.id); // Get the ID of the specific pair

//     this.setState(prevState => ({
//       datePairs: prevState.datePairs.map(pair =>
//         pair.id === pairId
//           ? { ...pair, [name]: value }
//           : pair
//       ),
//     }));

//     if (name === 'duration_from') {
//       const dateParts = value.split('-');
//       const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
//       this.setState({ Updateduration_from: formattedDate });
//     }
//     if (name === 'duration_to') {
//       const dateParts = value.split('-');
//       const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
//       this.setState({ Updateduration_to: formattedDate });
//     }
//     if (name === 'repeat') {
//       this.setState({ repeat: value });
//     }

//     if (type === 'checkbox') {
//       const updatedPackageOptions = [...this.state.packageOptions];

//       if (checked) {
//         if (!updatedPackageOptions.includes(value)) { // Check for existing value
//           updatedPackageOptions.push(value);
//         }
//       } else {
//         const index = updatedPackageOptions.indexOf(value);
//         if (index > -1) {
//           updatedPackageOptions.splice(index, 1);
//         }
//       }

//       this.setState({ packageOptions: updatedPackageOptions });
//     }
//     else {
//       this.setState({ [name]: value }, () => {
//         
//       });
//     }
//   };

//   addDatePair = () => {
//     this.setState(prevState => ({
//       datePairs: [
//         ...prevState.datePairs,
//         {
//           id: prevState.nextId,
//           duration_from: '',
//           duration_to: '',
//         },
//       ],
//       nextId: prevState.nextId + 1,
//     }));
//   };



//   handleInterval = (event) => {
//     this.setState({ interval: event.target.value }, () => {
//       
//     });
//   };
//   updateDisableStates() {
//     const { repeat, duration_from, duration_to } = this.state;

//     const isRepeatSelected = repeat !== 'Select Repeat Type';
//     const isDurationSelected = duration_from !== '' && duration_to !== '';

//     this.setState({
//       repeatDisabled: isDurationSelected, // Disable Repeat if Duration is selected
//       durationDisabled: isRepeatSelected, // Disable Duration if Repeat is selected
//     });
//   }

//   handleSubmit = async (event) => {
//     event.preventDefault();
//     this.setState({ loading: true, error: null }); // Set loading to true and clear previous errors
//     const formData = new FormData();
//     formData.append('title', this.state.title);
//     formData.append('description', this.state.description);
//     formData.append('price', this.state.price);
//     formData.append('labels', this.state.courseLabel);
//     formData.append('tags', this.state.courseTag);
//     formData.append('training_type', this.state.trainingType);
//     formData.append('repeat', this.state.repeat);
//     formData.append('interval', this.state.interval);
//     formData.append('duration_from', this.state.Updateduration_from);
//     formData.append('duration_to', this.state.Updateduration_to);
//     // Append package options as an array
//     formData.append('package', JSON.stringify(this.state.packageOptions));
//     if (this.state.selectedImages) {
//       formData.append('thumbnail', this.state.selectedImages);
//     }



//     try {
//       const { onCourseAdded } = this.props
//       const accessToken = localStorage.getItem('accessToken');
//       const response = await axios.post('https://api.geoinfoacademy.com/api/tutor/courses/', formData, {
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//         },
//       });
//       console.log('API response:', response);
//       this.setState({
//         title: '',
//         description: '',
//         price: 0,
//         trainingType: '',
//         repeat: 'Select Repeat Type',
//         interval: '',
//         duration_from: '',
//         Updateduration_from: '',
//         duration_to: '',
//         Updateduration_to: '',
//         packageOptions: [],
//         courseLabel: '',
//         courseTag: '',
//         selectedImage: null,
//         selectedImages: null,
//       });
//       const checkboxes = document.querySelectorAll('input[type="checkbox"]');
//       checkboxes.forEach(checkbox => {
//         checkbox.checked = false;
//       });
//       onCourseAdded();
//     } catch (error) {
//       console.error('Error submitting form:', error);

//     }
//     finally {
//       this.setState({ loading: false }); // Set loading to false after response
//     }
//   };


//   // end for the submition





//   handleFileChange = (event) => {
//     const file = event.target.files[0];
//     this.setState({ selectedImages: event.target.files[0] });
//     if (file && file.type.startsWith('image/')) {
//       const reader = new FileReader();

//       reader.onload = (e) => {
//         this.setState({ selectedImage: e.target.result });
//       };
//       reader.readAsDataURL(file);
//     }

//   };

//   handleDragOver = (event) => {
//     event.preventDefault();
//   };

//   handleDrop = (event) => {
//     event.preventDefault();
//     const file = event.dataTransfer.files[0];
//     this.handleFileChange({ target: { files: [file] } });
//   };

//   handleButtonClick = (e) => {
//     e.preventDefault()
//     this.fileInputRef.current.click();
//   };

//   handleCancelImage = (e) => {
//     e.preventDefault()
//     this.setState({ selectedImage: null });
//   };
//   // end of the image




//   // the display
//   handleOutsideClick = (event) => {
//     if (this.node && !this.node.contains(event.target)) {
//       this.setState({ isActive: false, });
//       const formdisplay = document.querySelector(".dash_add_course_cover")
//       formdisplay.style.display = "none"
//     }

//   };
//   componentDidMount() {
//     window.addEventListener('resize', this.handleResize);
//     document.addEventListener('mousedown', this.handleOutsideClick);
//   }

//   componentWillUnmount() {
//     window.removeEventListener('resize', this.handleResize);
//     document.removeEventListener('mousedown', this.handleOutsideClick);
//   }
//   handleResize = () => {
//     this.setState({ windowHeight: window.innerHeight - 60 });
//   };


//   render() {
//     const { selectedImage } = this.state;
//     const { menuCoverWidth } = this.state;
//     const { repeatDisabled, durationDisabled } = this.state;

//     console.log(this.state)
//     return (

//       <div className="dash_add_course_cover" style={{ width: `calc(100% - ${menuCoverWidth}px - 3px)`, height: this.state.windowHeight }}>
//         <div className="dash_form_container" ref={(node) => (this.node = node)}>
//           <h2>Add New Course</h2>
//           <p>Make sure to follow the instruction if any bellow the input </p>
//           <form onSubmit={this.handleSubmit} className='add_course_form'>
//             <label htmlFor="title">Title</label><br />
//             <input type="text" id='title' name="title" value={this.state.title} onChange={this.handleInputChange} placeholder="Input course title" required /><br /><br />
//             <label htmlFor="description">Describe the Course</label><br />
//             <textarea name="description" id='description' value={this.state.description} onChange={this.handleInputChange} placeholder="Describe the course" required /><br /><br />
//             <label htmlFor="price">Amount in Naria</label><br />
//             <input type="number" name="price" id='price' value={this.state.price} onChange={this.handleInputChange} min={0} placeholder="Price" required /><br /><br />

//             <label htmlFor="trainingType">Training Type</label><br />
//             <select name="trainingType" id='trainingType' value={this.state.trainingType} onChange={this.handleInputChange} required>
//               <option value="">Select Training Type</option>
//               <option value="Online Prerecorded">Online Prerecorded</option>
//               <option value="Online Live with Facilitator">Online Live with Facilitator</option>
//               <option value="General Physical Class">General Physical Class</option>
//               <option value="Physical Private Class">Physical Private Class</option>
//             </select><br /><br />

//             <label htmlFor="repeat">Repeat</label><br />
//             <select name="repeat" id='repeat' value={this.state.repeat} onChange={this.handleInputChange} required >
//               <option value="">Select Repeat Type</option>
//               <option value="Every Year">Every Year</option>
//               <option value="Every Month">Every Month</option>
//             </select><br /><br />

//             {/* {(this.state.repeat === 'Every Year' || this.state.repeat === 'Every Month') && (
//               <div>
//                 <label>Interval</label>
//                 <input
//                   type="text"
//                   placeholder="January to March, Week 1, August to October"
//                   value={this.state.interval}
//                   onChange={this.handleInterval}
//                   disabled={repeatDisabled}
//                 />
//                 <p className='info'>Follow the format on the input. If is more than one interval use a " , " and make sure each month or week are in capital letter </p>
//                 <br /></div>
//             )} */}
//             <label htmlFor="duration_from">Duration</label><br />
//             {/* <label htmlFor="duration_from">From</label>
//             <input type="date" id='duration_from' className="date" name="duration_from" value={this.state.duration_from} onChange={this.handleInputChange} />
//             <label htmlFor="duration_to"> To</label>
//             <input type="date" id='duration_to' className="date" name="duration_to" value={this.state.duration_to} onChange={this.handleInputChange} /><br /> */}
//             {this.state.datePairs.map(pair => (
//               <div key={pair.id}> {/* Key prop is essential for lists */}
//                 <label htmlFor={`duration_from-${pair.id}`}>From</label>
//                 <input
//                   type="date"
//                   id={`duration_from-${pair.id}`}
//                   className="date"
//                   name="duration_from"
//                   value={pair.duration_from}
//                   onChange={this.handleInputChange}
//                   data-id={pair.id} // Custom data attribute to pass the pair ID
//                 />
//                 <label htmlFor={`duration_to-${pair.id}`}> To</label>
//                 <input
//                   type="date"
//                   id={`duration_to-${pair.id}`}
//                   className="date"
//                   name="duration_to"
//                   value={pair.duration_to}
//                   onChange={this.handleInputChange}
//                   data-id={pair.id} // Custom data attribute to pass the pair ID
//                 />
//                 <br />
//               </div>
//             ))}

//             <button type='button' className='add' onClick={this.addDatePair}>+ Add duration</button><br /><br />

//             <label>Package</label><br />

//             <input type="checkbox" className="check" id="software" name="software" value="Software" onChange={this.handleInputChange} />
//             <label htmlFor="software" className="check">Software</label>

//             <input type="checkbox" id="data" name="data" value="Data" className="check" onChange={this.handleInputChange} />
//             <label htmlFor="data" className="check">Data</label>

//             <input type="checkbox" id="biro" name="biro" value="Biro" className="check" onChange={this.handleInputChange} />
//             <label htmlFor="biro" className="check">Biro</label>

//             <input type="checkbox" id="jotter" name="jotter" value="Jotter" className="check" onChange={this.handleInputChange} />
//             <label htmlFor="jotter" className="check">Jotter</label>

//             <input type="checkbox" id="manual" name="manual" value="Manual" className="check" onChange={this.handleInputChange} />
//             <label htmlFor="manual" className="check">Manual</label>

//             <input type="checkbox" id="practical" name="practical" value="100% Practical" className="check" onChange={this.handleInputChange} />
//             <label htmlFor="practical" className="check">100% Practical</label>

//             <input type="checkbox" id="field" name="field" value="Field Experience" className="check" onChange={this.handleInputChange} />
//             <label htmlFor="field" className="check">Field Experience</label>

//             <input type="checkbox" id="consultation" name="consultation" value="Free Consultation" className="check" onChange={this.handleInputChange} />
//             <label htmlFor="consultation" className="check">Free Consultation</label>

//             <input type="checkbox" id="exam" name="exam" value="Exam and Certificate" className="check" onChange={this.handleInputChange} />
//             <label htmlFor="exam" className="check">Exam and Certificate</label><br />

//             <input type="checkbox" id="internship" name="internship" value="Free internship" className="check" onChange={this.handleInputChange} />
//             <label htmlFor="internship" className="check">Free internship</label>

//             <input type="checkbox" id="opportunities" name="opportunities" value="Access job opportunities" className="check" onChange={this.handleInputChange} />
//             <label htmlFor="opportunities" className="check">Access job opportunities</label><br /><br />


//             <label htmlFor="thumb">Upload Thumb</label><br />
//             <div className="image-uploader">
//               <div className="drop-zone"
//                 onDragOver={this.handleDragOver}
//                 onDrop={this.handleDrop}>
//                 {selectedImage ? (
//                   <div className="image-preview">
//                     <img src={selectedImage} alt="Preview" />
//                     <button onClick={this.handleCancelImage}>Cancel</button>
//                   </div>
//                 ) : (
//                   <div className="drop-zone-text">
//                     Drag and drop an image here<br />
//                     or <button onClick={this.handleButtonClick}>Click to select</button>
//                   </div>
//                 )}
//               </div>
//               <input
//                 type="file"
//                 id='thumb'
//                 accept="image/*"
//                 onChange={this.handleFileChange}
//                 ref={this.fileInputRef}
//                 style={{ display: 'none' }}
//                 required
//               />
//             </div><br /><br />


//             <label htmlFor="courseLabel">Course Label</label><br />
//             <select name="courseLabel" id='courseLabel' value={this.state.courseLabel} onChange={this.handleInputChange} required>
//               <option value="">Select Course Label  </option>
//               <option value="GIS">GIS </option>
//               <option value="Drone">Drone</option>
//               <option value="Remote Sensing">Remote Sensing</option>
//               <option value="Survey">Survey</option>
//               <option value="Mapping">Mapping</option>
//               <option value="Engineering">Engineering</option>
//               <option value="Geo Programming">Geo Pragramming</option>
//               <option value="Event">Event (Summit/Workshop/Conference)</option>
//               <option value="Webinar">Webinar</option>
//               <option value="Podcast">Podcast</option>
//             </select><br /><br />
//             <label htmlFor="courseTag">Course Tag</label><br />
//             <select name="courseTag" id='courseTag' value={this.state.courseTag} onChange={this.handleInputChange} required>
//               <option value="">Select Course Tag</option>
//               <option value="Beginner">Beginner</option>
//               <option value="Intermediate">Intermediate</option>
//               <option value="Advance">Advance</option>
//               <option value="Professional">Professional</option>
//               <option value="Beginner to Intermediate">Beginner to Intermediate</option>
//               <option value="Beginner to Advance">Beginner to Advance</option>
//               <option value="Beginner to Professional">Beginner to Professional</option>
//             </select><br /><br />
//             <button type="submit" disabled={this.state.loading}>
//               {this.state.loading ? "Uploading..." : "Submit"}
//             </button>
//           </form>
//         </div>
//       </div>


//     );
//   }
// }

// export default AddCourseUploader;


import React, { Component } from 'react';
import axios from 'axios';
// Uncomment these icon imports if you are using them in your project
// import { FaAppStore } from "react-icons/fa";
// import { AiOutlineDatabase } from "react-icons/ai";
// import { CiPen } from "react-icons/ci";
// import { GiBlackBook } from "react-icons/gi";
// import { LuNotebook } from "react-icons/lu";
// import { MdOutlineVerifiedUser } from "react-icons/md";
// import { GiField } from "react-icons/gi";
// import { MdOutlinePhoneInTalk } from "react-icons/md";
// import { PiCertificate } from "react-icons/pi";
// import { MdOutlineVerified } from "react-icons/md";


class AddCourseUploader extends Component {
  state = {
    title: '',
    description: '',
    price: 0,
    trainingType: '',
    repeat: '', // Changed to empty string for 'Select Repeat Type' default option
    // Removed 'interval'
    // Removed 'duration_from', 'Updateduration_from', 'duration_to', 'Updateduration_to'
    packageOptions: [],
    courseLabel: '',
    courseTag: '',
    selectedImage: null,
    selectedImages: null,
    // Removed 'isActive'
    windowHeight: window.innerHeight - 60,
    repeatDisabled: false,
    durationDisabled: false,
    loading: false,
    datePairs: [
      {
        id: 1,
        duration_from: '',
        duration_to: '',
      },
    ],
    nextId: 2,
    isEditMode: false, // Tracks if the form is in edit mode
    error: null, // To display API or form submission errors
  };

  fileInputRef = React.createRef();

  formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.warn("Invalid date string received for input formatting:", dateString);
      return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  formatDateForApi = (dateString) => {
    if (!dateString) return '';
    // Assuming dateString is 'YYYY-MM-DD' from date input
    const dateParts = dateString.split('-');
    if (dateParts.length !== 3) {
      console.warn("Invalid date string for API formatting:", dateString);
      return '';
    }
    return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`; // Convert to DD-MM-YYYY or whatever your API expects
  };

  async fetchCourseData(courseId) {
    const course_Id = parseInt(courseId, 10);
    console.log(`[fetchCourseData] Attempting to fetch course with ID: ${course_Id}`);
    this.setState({ loading: true, error: null });

    try {
      const accessToken = localStorage.getItem('accessToken');
      if (!accessToken) {
        throw new Error("Access token not found. Please log in.");
      }

      const response = await axios.get(`https://api.geoinfoacademy.com/api/tutor/courses/${course_Id}/`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const courseData = response.data;
      console.log("[fetchCourseData] Fetched course data:", courseData);

      let fetchedDatePairs = [{ id: 1, duration_from: '', duration_to: '' }];
      if (courseData.duration.length > 0) {
        // If your API can return multiple duration pairs, you'd loop here.
        // Assuming it returns one primary duration for now.
        fetchedDatePairs = courseData.duration
      }

      this.setState({
        title: courseData.title || '',
        description: courseData.description || '',
        price: courseData.price || 0,
        trainingType: courseData.training_type || '',
        repeat: courseData.repeat || '', // Use empty string if null/undefined
        // Removed 'interval' assignment
        packageOptions: Array.isArray(courseData.package) ? courseData.package : [],
        courseLabel: courseData.labels || '',
        courseTag: courseData.tags || '',
        selectedImage: courseData.thumbnail || null, // Existing image URL
        selectedImages: null, // No new file selected yet
        datePairs: fetchedDatePairs,
        nextId: fetchedDatePairs.length > 0 ? fetchedDatePairs[fetchedDatePairs.length - 1].id + 1 : 2,
        isEditMode: true, // We are in edit mode
      }, () => {
        console.log("[fetchCourseData] State updated after fetching:", this.state);
         // Re-evaluate disable states after loading data

        // Manually update checkboxes after state has been set to reflect fetched data
        document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => checkbox.checked = false); // Clear all
        this.state.packageOptions.forEach(option => {
          const checkbox = document.querySelector(`input[value="${option}"]`);
          if (checkbox) {
            checkbox.checked = true; // Check if option is in fetched data
          }
        });
      });

    } catch (error) {
      console.error('Error fetching course data:', error.response ? error.response.data : error.message);
      this.setState({
        error: error.response?.data?.detail || JSON.stringify(error.response?.data) || 'Failed to fetch course data.',
        // On fetch error for a specific ID, revert to a clean add mode form state
        title: '', description: '', price: 0, trainingType: '', repeat: '',
        packageOptions: [], courseLabel: '', courseTag: '', selectedImage: null, selectedImages: null,
        datePairs: [{ id: 1, duration_from: '', duration_to: '' }], nextId: 2, isEditMode: false,
      });
    } finally {
      this.setState({ loading: false });
    }
  }


  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mousedown', this.handleOutsideClick);

    if (this.props.courseId) {
      console.log("[componentDidMount] courseId prop detected:", this.props.courseId);
      this.fetchCourseData(this.props.courseId);
    } else {
      console.log("[componentDidMount] No courseId prop. Initializing for add mode.");
      this.resetForm(); // Reset form for fresh "add new" experience
    }
  }

  async componentDidUpdate(prevProps) {
    // If courseId changes (e.g., switching from editing one course to another)
    if (this.props.courseId && this.props.courseId !== prevProps.courseId) {
      console.log(`[componentDidUpdate] courseId changed from ${prevProps.courseId} to ${this.props.courseId}. Fetching new data.`);
      this.fetchCourseData(this.props.courseId);
    }
    // If courseId is removed (e.g., parent switches from 'edit' mode to 'add' mode)
    else if (!this.props.courseId && prevProps.courseId) {
      console.log("[componentDidUpdate] Transitioning from edit mode to add mode. Resetting form.");
      this.resetForm();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  handleResize = () => {
    this.setState({ windowHeight: window.innerHeight - 60 });
  };

  handleInputChange = (event) => {
    const { name, value, type, checked, dataset } = event.target;

    if (type === 'checkbox') {
      const updatedPackageOptions = [...this.state.packageOptions];

      if (checked) {
        if (!updatedPackageOptions.includes(value)) {
          updatedPackageOptions.push(value);
        }
      } else {
        const index = updatedPackageOptions.indexOf(value);
        if (index > -1) {
          updatedPackageOptions.splice(index, 1);
        }
      }
      this.setState({ packageOptions: updatedPackageOptions });
    } else if (name === 'duration_from' || name === 'duration_to') {
      const pairId = parseInt(dataset.id);
      this.setState(prevState => ({
        datePairs: prevState.datePairs.map(pair =>
          pair.id === pairId
            ? { ...pair, [name]: value }
            : pair
        ),
      }), () => {
         // Re-evaluate disable states after duration change
      });
    }
    else {
      this.setState({ [name]: value }, () => {
         // Re-evaluate disable states after other changes
      });
    }
  };

  addDatePair = () => {
    this.setState(prevState => ({
      datePairs: [
        ...prevState.datePairs,
        {
          id: prevState.nextId,
          duration_from: '',
          duration_to: '',
        },
      ],
      nextId: prevState.nextId + 1,
    }));
  };



  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true, error: null }); // Set loading to true and clear previous errors
    console.log("[handleSubmit] Submitting form...");

    const formData = new FormData();
    formData.append('title', this.state.title);
    formData.append('description', this.state.description);
    formData.append('price', this.state.price);
    formData.append('labels', this.state.courseLabel);
    formData.append('tags', this.state.courseTag);
    formData.append('training_type', this.state.trainingType);
 
    // Append repeat and interval (if applicable) duration

   // if (this.state.repeat && this.state.repeat !== '') {  Only append if a repeat option is selected
      formData.append('repeat', this.state.repeat);
      // Removed interval logic based on your request. If needed, re-add here.
    //}

    // Append duration from the first valid date pair if repeat is not selected
    // if (!this.state.repeatDisabled && this.state.datePairs.length > 0) {
    //   const firstValidPair = this.state.datePairs.find(pair => pair.duration_from && pair.duration_to);
    //   if (firstValidPair) {
    //     formData.append('duration_from', this.formatDateForApi(firstValidPair.duration_from));
    //     formData.append('duration_to', this.formatDateForApi(firstValidPair.duration_to));
    //   }
    // }
    formData.append('duration', JSON.stringify(this.state.datePairs));


    // Append package options as a JSON string
    formData.append('package', JSON.stringify(this.state.packageOptions));

    // Append thumbnail only if a new file is selected, or if existing one is cancelled in edit mode
    if (this.state.selectedImages) {
      formData.append('thumbnail', this.state.selectedImages);
    } else if (this.state.isEditMode && this.state.selectedImage === null) {
      // If in edit mode and image was previously set but now cleared (selectedImage is null),
      // send an empty string to remove it from the backend.
      console.log("[handleSubmit] User cancelled existing thumbnail. Sending empty string for thumbnail.");
      formData.append('thumbnail', '');
    }


    try {
      const { onCourseAdded, courseId } = this.props;
      const accessToken = localStorage.getItem('accessToken');
      const headers = { Authorization: `Bearer ${accessToken}` };

      let response;
      if (courseId) {
        // Update existing course (PUT request)
        const course_Id = parseInt(courseId, 10);
        console.log(`[handleSubmit] Updating course with ID: ${course_Id}`);
        response = await axios.put(`https://api.geoinfoacademy.com/api/tutor/courses/${course_Id}/`, formData, { headers });
        console.log('Course updated successfully:', response.data);
        // Do NOT reset form on successful update as per your requirement
      } else {
        // Create new course (POST request)
        console.log("[handleSubmit] Creating new course.");
        response = await axios.post('https://api.geoinfoacademy.com/api/tutor/courses/', formData, { headers });
        console.log('Course created successfully:', response.data);
        this.resetForm(); // Reset form ONLY on successful new course creation
      }

      if (onCourseAdded) {
        onCourseAdded(); // Callback to parent component (e.g., to refresh course list or close form)
      }

    } catch (error) {
      console.error('Error submitting form:', error.response ? error.response.data : error.message);
      this.setState({
        error: error.response?.data?.detail || JSON.stringify(error.response?.data) || 'An error occurred. Please try again.'
      });
    } finally {
      this.setState({ loading: false }); // Set loading to false after response (success or error)
    }
  };

  resetForm = () => {
    console.log("[resetForm] Resetting form fields.");
    this.setState({
      title: '',
      description: '',
      price: 0,
      trainingType: '',
      repeat: '', // Reset to empty string
      // Removed 'interval' reset
      // Removed 'duration_from', 'Updateduration_from', 'duration_to', 'Updateduration_to' reset
      packageOptions: [],
      courseLabel: '',
      courseTag: '',
      selectedImage: null,
      selectedImages: null,
      datePairs: [{ id: 1, duration_from: '', duration_to: '' }], // Reset to a single empty pair
      nextId: 2,
      repeatDisabled: false,
      durationDisabled: false,
      isEditMode: false, // Ensure it's not in edit mode after reset
      error: null,
    });
    // Uncheck all checkboxes manually
    document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = false;
    });
    // Clear the file input visually
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = "";
    }
  };

  handleFileChange = (event) => {
    const file = event.target.files[0];
    this.setState({ selectedImages: file }); // Store the actual File object for upload
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.setState({ selectedImage: e.target.result }); // Store Data URL for preview
      };
      reader.readAsDataURL(file);
    } else {
      this.setState({ selectedImage: null }); // Clear preview if not an image
    }
  };

  handleDragOver = (event) => {
    event.preventDefault();
  };

  handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    this.handleFileChange({ target: { files: [file] } });
  };

  handleButtonClick = (e) => {
    e.preventDefault();
    this.fileInputRef.current.click();
  };

  handleCancelImage = (e) => {
    e.preventDefault();
    console.log("[handleCancelImage] Clearing selected image.");
    this.setState({ selectedImage: null, selectedImages: null }); // Clear preview and actual file
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = ""; // Clear file input visual
    }
  };

  // The display control as per your request
  handleOutsideClick = (event) => {
    if (this.node && !this.node.contains(event.target)) {
      const formdisplay = document.querySelector("div.dash_add_course_cover");
      if (formdisplay) {
        formdisplay.style.display = "none";
      }
    }
  };


  render() {
    const { selectedImage, durationDisabled, isEditMode, loading, error } = this.state;
    // Removed menuCoverWidth from destructuring and style as it's no longer in state or used dynamically

    const submitButtonText = loading ?
      (isEditMode ? "Updating..." : "Uploading...") :
      (isEditMode ? "Update Course" : "Submit");

    return (
      // The 'dash_add_course_cover' div's display is now controlled by handleOutsideClick and parent's initial setup
      <div className="dash_add_course_cover" style={{ height: this.state.windowHeight }}>
        <div className="dash_form_container" ref={(node) => (this.node = node)}>
          <h2>{isEditMode ? `Edit Course (ID: ${this.props.courseId})` : "Add New Course"}</h2>
          <p>Make sure to follow the instruction if any below the input</p>
          {error && <p style={{ color: 'red', fontWeight: 'bold' }}>Error: {error}</p>}

          <form onSubmit={this.handleSubmit} className='add_course_form'>
            <label htmlFor="title">Title</label><br />
            <input type="text" id='title' name="title" value={this.state.title} onChange={this.handleInputChange} placeholder="Input course title" required /><br /><br />

            <label htmlFor="description">Describe the Course</label><br />
            <textarea name="description" id='description' value={this.state.description} onChange={this.handleInputChange} placeholder="Describe the course" required /><br /><br />

            <label htmlFor="price">Amount in Naira</label><br />
            <input type="number" name="price" id='price' value={this.state.price} onChange={this.handleInputChange} min={0} placeholder="Price" required /><br /><br />

            <label htmlFor="trainingType">Training Type</label><br />
            <select name="trainingType" id='trainingType' value={this.state.trainingType} onChange={this.handleInputChange} required>
              <option value="">Select Training Type</option>
              <option value="Online Prerecorded">Online Prerecorded</option>
              <option value="Online Live with Facilitator">Online Live with Facilitator</option>
              <option value="General Physical Class">General Physical Class</option>
              <option value="Physical Private Class">Physical Private Class</option>
            </select><br /><br />

            <label htmlFor="repeat">Repeat</label><br />
            <select name="repeat" id='repeat' value={this.state.repeat} onChange={this.handleInputChange} required>
              <option value="">Select Repeat Type</option>
              <option value="Every Year">Every Year</option>
              <option value="Every Month">Every Month</option>
              {/* <option value="None">None</option>  Added 'None' option as it was previously considered */}
            </select><br /><br />

            {/* Removed interval section as per your request */}
 
            <label>Duration</label><br />
            {this.state.datePairs.map(pair => (
              <div key={pair.id}>
                <label htmlFor={`duration_from-${pair.id}`}>From</label>
                <input
                  type="date"
                  id={`duration_from-${pair.id}`}
                  className="date"
                  name="duration_from"
                  value={pair.duration_from}
                  onChange={this.handleInputChange}
                  data-id={pair.id} // Custom data attribute to pass the pair ID
                  required
                />
                <label htmlFor={`duration_to-${pair.id}`}> To</label>
                <input
                  type="date"
                  id={`duration_to-${pair.id}`}
                  className="date"
                  name="duration_to"
                  value={pair.duration_to}
                  onChange={this.handleInputChange}
                  data-id={pair.id} // Custom data attribute to pass the pair ID
                  required
                /><br />
              </div>
            ))}

            <button type='button' className='add' onClick={this.addDatePair} disabled={durationDisabled}>+ Add duration</button><br /><br />

            <label>Package</label><br />

            <input type="checkbox" className="check" id="software" name="software" value="Software" onChange={this.handleInputChange} checked={this.state.packageOptions.includes("Software")} />
            <label htmlFor="software" className="check">Software</label>

            <input type="checkbox" id="data" name="data" value="Data" className="check" onChange={this.handleInputChange} checked={this.state.packageOptions.includes("Data")} />
            <label htmlFor="data" className="check">Data</label>

            <input type="checkbox" id="biro" name="biro" value="Biro" className="check" onChange={this.handleInputChange} checked={this.state.packageOptions.includes("Biro")} />
            <label htmlFor="biro" className="check">Biro</label>

            <input type="checkbox" id="jotter" name="jotter" value="Jotter" className="check" onChange={this.handleInputChange} checked={this.state.packageOptions.includes("Jotter")} />
            <label htmlFor="jotter" className="check">Jotter</label>

            <input type="checkbox" id="manual" name="manual" value="Manual" className="check" onChange={this.handleInputChange} checked={this.state.packageOptions.includes("Manual")} />
            <label htmlFor="manual" className="check">Manual</label>

            <input type="checkbox" id="practical" name="practical" value="100% Practical" className="check" onChange={this.handleInputChange} checked={this.state.packageOptions.includes("100% Practical")} />
            <label htmlFor="practical" className="check">100% Practical</label>

            <input type="checkbox" id="field" name="field" value="Field Experience" className="check" onChange={this.handleInputChange} checked={this.state.packageOptions.includes("Field Experience")} />
            <label htmlFor="field" className="check">Field Experience</label>

            <input type="checkbox" id="consultation" name="consultation" value="Free Consultation" className="check" onChange={this.handleInputChange} checked={this.state.packageOptions.includes("Free Consultation")} />
            <label htmlFor="consultation" className="check">Free Consultation</label>

            <input type="checkbox" id="exam" name="exam" value="Exam and Certificate" className="check" onChange={this.handleInputChange} checked={this.state.packageOptions.includes("Exam and Certificate")} />
            <label htmlFor="exam" className="check">Exam and Certificate</label><br />

            <input type="checkbox" id="internship" name="internship" value="Free internship" className="check" onChange={this.handleInputChange} checked={this.state.packageOptions.includes("Free internship")} />
            <label htmlFor="internship" className="check">Free internship</label>

            <input type="checkbox" id="opportunities" name="opportunities" value="Access job opportunities" className="check" onChange={this.handleInputChange} checked={this.state.packageOptions.includes("Access job opportunities")} />
            <label htmlFor="opportunities" className="check">Access job opportunities</label><br /><br />


            <label htmlFor="thumb">Upload Thumbnail</label><br />
            <div className="image-uploader">
              <div className="drop-zone"
                onDragOver={this.handleDragOver}
                onDrop={this.handleDrop}>
                {selectedImage ? (
                  <div className="image-preview">
                    <img src={selectedImage} alt="Preview" />
                    <button onClick={this.handleCancelImage}>Cancel</button>
                  </div>
                ) : (
                  <div className="drop-zone-text">
                    Drag and drop an image here<br />
                    or <button onClick={this.handleButtonClick}>Click to select</button>
                  </div>
                )}
              </div>
              <input
                type="file"
                id='thumb'
                accept="image/*"
                onChange={this.handleFileChange}
                ref={this.fileInputRef}
                style={{ display: 'none' }}
                // required // Now always required as per your request
              />
            </div><br /><br />


            <label htmlFor="courseLabel">Course Label</label><br />
            <select name="courseLabel" id='courseLabel' value={this.state.courseLabel} onChange={this.handleInputChange} required>
              <option value="">Select Course Label</option>
              <option value="GIS">GIS</option>
              <option value="Drone">Drone</option>
              <option value="Remote Sensing">Remote Sensing</option>
              <option value="Survey">Survey</option>
              <option value="Mapping">Mapping</option>
              <option value="Engineering">Engineering</option>
              <option value="Geo Programming">Geo Programming</option>
              <option value="Event">Event (Summit/Workshop/Conference)</option>
              <option value="Webinar">Webinar</option>
              <option value="Podcast">Podcast</option>
            </select><br /><br />
            <label htmlFor="courseTag">Course Tag</label><br />
            <select name="courseTag" id='courseTag' value={this.state.courseTag} onChange={this.handleInputChange} required>
              <option value="">Select Course Tag</option>
              <option value="Beginner">Beginner</option>
              <option value="Intermediate">Intermediate</option>
              <option value="Advance">Advance</option>
              <option value="Professional">Professional</option>
              <option value="Beginner to Intermediate">Beginner to Intermediate</option>
              <option value="Beginner to Advance">Beginner to Advance</option>
              <option value="Beginner to Professional">Beginner to Professional</option>
            </select><br /><br />
            <button type="submit" disabled={this.state.loading}>
              {submitButtonText}
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default AddCourseUploader;